export default {"src":"/_next/static/media/merciii.74f93b14.svg","height":396,"width":400,"blurWidth":0,"blurHeight":0};